import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m2.5 2.5 3 3m0 0 2.73 2.73M5.5 5.5l6.28 6.28M5.49 5.49A8.34 8.34 0 0 1 17.95 10a8.35 8.35 0 0 1-3.44 4.52m2.99 2.99-3-3m0 0-2.73-2.73m-.2 3.92A8.37 8.37 0 0 1 2.04 10a8.3 8.3 0 0 1 1.3-2.52m4.88.75A2.5 2.5 0 0 1 12.5 10a2.5 2.5 0 0 1-.73 1.77M8.23 8.23l3.54 3.54"
    }, null, -1)
  ])))
}
export default { render: render }